// extracted by mini-css-extract-plugin
export default {"tostwrapper":"Toasts_tostwrapper__gruyf"};